module.exports = __webpack_public_path__ + "static/media/app_store.78f780a7.jpg";